import "@/styles/index.scss";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./i18n/config.ts";
import styles from "@/styles/App.module.scss";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./components/app/ErrorBoundaryOutsideAuth.tsx";
import IntercomProvider from "./providers/Intercom.tsx";
import RouterSetup from "./components/RouterSetup.tsx";
import { queryClient } from "./lib/queryClient.ts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary className={styles.topLevelErrorBoundary}>
      <QueryClientProvider client={queryClient}>
        <IntercomProvider>
          <RouterSetup />
        </IntercomProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
